import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.ts'), 'store/index.ts')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/AlertStore.ts'), 'AlertStore.ts')
  resolveStoreModules(require('../store/AppStore.ts'), 'AppStore.ts')
  resolveStoreModules(require('../store/AuthorityStore.ts'), 'AuthorityStore.ts')
  resolveStoreModules(require('../store/AuthUserStore.ts'), 'AuthUserStore.ts')
  resolveStoreModules(require('../store/BaseStore.ts'), 'BaseStore.ts')
  resolveStoreModules(require('../store/BibliographyDetailSetStore.ts'), 'BibliographyDetailSetStore.ts')
  resolveStoreModules(require('../store/BibliographyDetailStore.ts'), 'BibliographyDetailStore.ts')
  resolveStoreModules(require('../store/BibliographySearchStore.ts'), 'BibliographySearchStore.ts')
  resolveStoreModules(require('../store/CollectionListStore.ts'), 'CollectionListStore.ts')
  resolveStoreModules(require('../store/DataStore.ts'), 'DataStore.ts')
  resolveStoreModules(require('../store/DonorStore.ts'), 'DonorStore.ts')
  resolveStoreModules(require('../store/FelicaStore.ts'), 'FelicaStore.ts')
  resolveStoreModules(require('../store/GlobalSystemParameterStore.ts'), 'GlobalSystemParameterStore.ts')
  resolveStoreModules(require('../store/IcTagStore.ts'), 'IcTagStore.ts')
  resolveStoreModules(require('../store/LendBooksCountConfirmationStore.ts'), 'LendBooksCountConfirmationStore.ts')
  resolveStoreModules(require('../store/LendStore.ts'), 'LendStore.ts')
  resolveStoreModules(require('../store/ModalAlertStore.ts'), 'ModalAlertStore.ts')
  resolveStoreModules(require('../store/ModalBibliographyDetailRealStore.ts'), 'ModalBibliographyDetailRealStore.ts')
  resolveStoreModules(require('../store/ModalBibliographyDetailSetStore.ts'), 'ModalBibliographyDetailSetStore.ts')
  resolveStoreModules(require('../store/ModalBibliographyDetailStore.ts'), 'ModalBibliographyDetailStore.ts')
  resolveStoreModules(require('../store/ModalBibliographySearchConditionStore.ts'), 'ModalBibliographySearchConditionStore.ts')
  resolveStoreModules(require('../store/ModalBibliographySearchHistoryStore.ts'), 'ModalBibliographySearchHistoryStore.ts')
  resolveStoreModules(require('../store/ModalBibliographySearchResultAuthorityStore.ts'), 'ModalBibliographySearchResultAuthorityStore.ts')
  resolveStoreModules(require('../store/ModalBibliographySearchResultContentStore.ts'), 'ModalBibliographySearchResultContentStore.ts')
  resolveStoreModules(require('../store/ModalBibliographySearchResultStore.ts'), 'ModalBibliographySearchResultStore.ts')
  resolveStoreModules(require('../store/ModalBibliographySearchStore.ts'), 'ModalBibliographySearchStore.ts')
  resolveStoreModules(require('../store/ModalBibliographyTagDataEditStore.ts'), 'ModalBibliographyTagDataEditStore.ts')
  resolveStoreModules(require('../store/ModalCodeKeyStore.ts'), 'ModalCodeKeyStore.ts')
  resolveStoreModules(require('../store/ModalCodeStore.ts'), 'ModalCodeStore.ts')
  resolveStoreModules(require('../store/ModalCollectionEditStore.ts'), 'ModalCollectionEditStore.ts')
  resolveStoreModules(require('../store/ModalCollectionSelectStore.ts'), 'ModalCollectionSelectStore.ts')
  resolveStoreModules(require('../store/ModalErrorStore.ts'), 'ModalErrorStore.ts')
  resolveStoreModules(require('../store/ModalJobListStore.ts'), 'ModalJobListStore.ts')
  resolveStoreModules(require('../store/ModalOrderEditStore.ts'), 'ModalOrderEditStore.ts')
  resolveStoreModules(require('../store/ModalProcessPlaceChangeStore.ts'), 'ModalProcessPlaceChangeStore.ts')
  resolveStoreModules(require('../store/ModalQuickMenuStore.ts'), 'ModalQuickMenuStore.ts')
  resolveStoreModules(require('../store/ModalReceiptHistoryStore.ts'), 'ModalReceiptHistoryStore.ts')
  resolveStoreModules(require('../store/ModalReturnCheckAlertStore.ts'), 'ModalReturnCheckAlertStore.ts')
  resolveStoreModules(require('../store/ModalReturnHistoryStore.ts'), 'ModalReturnHistoryStore.ts')
  resolveStoreModules(require('../store/ModalShelfDiagramStore.ts'), 'ModalShelfDiagramStore.ts')
  resolveStoreModules(require('../store/ModalUpdateCollectionMemoStore.ts'), 'ModalUpdateCollectionMemoStore.ts')
  resolveStoreModules(require('../store/ModalUpdateOrderMemoStore.ts'), 'ModalUpdateOrderMemoStore.ts')
  resolveStoreModules(require('../store/ModalUserDetailStore.ts'), 'ModalUserDetailStore.ts')
  resolveStoreModules(require('../store/ModalUserSearchStore.ts'), 'ModalUserSearchStore.ts')
  resolveStoreModules(require('../store/PageStore.ts'), 'PageStore.ts')
  resolveStoreModules(require('../store/ReferenceImageMasterStore.ts'), 'ReferenceImageMasterStore.ts')
  resolveStoreModules(require('../store/ReferenceListStore.ts'), 'ReferenceListStore.ts')
  resolveStoreModules(require('../store/ReferenceStore.ts'), 'ReferenceStore.ts')
  resolveStoreModules(require('../store/ReservationCandidateListStore.ts'), 'ReservationCandidateListStore.ts')
  resolveStoreModules(require('../store/ReservationContactPageStore.ts'), 'ReservationContactPageStore.ts')
  resolveStoreModules(require('../store/ReturnPageStore.ts'), 'ReturnPageStore.ts')
  resolveStoreModules(require('../store/ReWriteCardStore.ts'), 'ReWriteCardStore.ts')
  resolveStoreModules(require('../store/SystemCodeKeyStore.ts'), 'SystemCodeKeyStore.ts')
  resolveStoreModules(require('../store/SystemCodeStore.ts'), 'SystemCodeStore.ts')
  resolveStoreModules(require('../store/SystemParameterKeyStore.ts'), 'SystemParameterKeyStore.ts')
  resolveStoreModules(require('../store/SystemParameterStore.ts'), 'SystemParameterStore.ts')
  resolveStoreModules(require('../store/TraderStore.ts'), 'TraderStore.ts')
  resolveStoreModules(require('../store/UserStore.ts'), 'UserStore.ts')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const storeModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(storeModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
